<template>
  <div v-if="mainHeroBannerImageUrl">
    <component :is="linkConfig.element" v-bind="linkConfig.attrs">
      <!-- AVIF first (about 30 % smaller than WebP, as fast for LexasCMS to convert), WebP for older browsers -->
      <picture>
        <source
          v-if="desktopHeroBannerImageUrl && lexasSrcset(desktopHeroBannerImageUrl, DESKTOP_WIDTHS, desktopImage.width, 'avif')"
          type="image/avif"
          :srcset="lexasSrcset(desktopHeroBannerImageUrl, DESKTOP_WIDTHS, desktopImage.width, 'avif')"
          sizes="100vw"
          :width="desktopImage.width"
          :height="desktopImage.height"
          media="(min-width: 1024px)"
        >
        <source
          v-if="desktopHeroBannerImageUrl"
          :srcset="lexasSrcset(desktopHeroBannerImageUrl, DESKTOP_WIDTHS, desktopImage.width) || desktopHeroBannerImageUrl"
          sizes="100vw"
          :width="desktopImage.width"
          :height="desktopImage.height"
          media="(min-width: 1024px)"
        >
        <source
          v-if="lexasSrcset(mainHeroBannerImageUrl, MOBILE_WIDTHS, mobileImage.width, 'avif')"
          type="image/avif"
          :srcset="lexasSrcset(mainHeroBannerImageUrl, MOBILE_WIDTHS, mobileImage.width, 'avif')"
          sizes="100vw"
          :width="mobileImage.width"
          :height="mobileImage.height"
        >
        <!-- width/height reserve the space before the image loads (the banners below used to jump: CLS) -->
        <img
          :src="lexasImage(mainHeroBannerImageUrl)"
          :srcset="lexasSrcset(mainHeroBannerImageUrl, MOBILE_WIDTHS, mobileImage.width) || undefined"
          sizes="100vw"
          :width="mobileImage.width"
          :height="mobileImage.height"
          :alt="altText"
          loading="eager"
          fetchpriority="high"
          class="w-full h-auto"
        >
      </picture>
    </component>
  </div>
</template>

<script setup>
import { useLexas } from '~/composables/useLexas'
import { lexasImage, lexasSrcset } from '~/helpers/lexasImage'

const MOBILE_WIDTHS = [400, 640, 828]
const DESKTOP_WIDTHS = [1024, 1280, 1536, 1920]

const route = useRoute()
const { getHeroBannerListByPath } = useLexas()
// Fetch hero banners based on the current route path
const banners = await getHeroBannerListByPath(route.path)
const { mobileImage = {}, desktopImage = {}, link = '' } = banners?.[0] || {}

const mainHeroBannerImageUrl = computed(() => mobileImage.url || '')
const desktopHeroBannerImageUrl = computed(() => desktopImage?.url || '')
const altText = computed(() => mobileImage?.altText || desktopImage?.altText || '')

// Check if the link is an external
const isExternal = computed(() => /^(http|https):\/\//.test(link))
const NuxtLink = resolveComponent('NuxtLink')

const linkConfig = computed(() => {
  return link
    ? isExternal.value
      // If the link is external, use an anchor tag with target and rel attributes
      ? { element: 'a', attrs: { href: link, target: '_blank', rel: 'noopener noreferrer' } }
      // If the link is internal, use NuxtLink
      : { element: NuxtLink, attrs: { to: link } }
    // If there's no link, return a div
    : { element: 'div', attrs: {} }
})
</script>
